import { downloadCSV, downloadXLSX, todayStamp } from '../lib/csv'

interface Props {
  name: string
  rows: Record<string, unknown>[] | null
  disabled?: boolean
}

export function ExportButtons({ name, rows, disabled }: Props) {
  const count = rows?.length ?? 0
  const isDisabled = disabled || count === 0

  const baseFile = `${name}_${todayStamp()}`

  return (
    <div className="flex items-center gap-2">
      <span className="text-xs text-slate-500">{count} rows</span>
      <button
        disabled={isDisabled}
        onClick={() => rows && downloadCSV(`${baseFile}.csv`, rows)}
        className="text-xs px-2.5 py-1.5 rounded border border-slate-700 text-slate-200 hover:bg-slate-800 disabled:opacity-50 disabled:hover:bg-transparent"
      >
        Export CSV
      </button>
      <button
        disabled={isDisabled}
        onClick={() => rows && downloadXLSX(`${baseFile}.xlsx`, rows, name)}
        className="text-xs px-2.5 py-1.5 rounded border border-emerald-700/60 text-emerald-200 hover:bg-emerald-900/30 disabled:opacity-50 disabled:hover:bg-transparent"
      >
        Export Excel
      </button>
    </div>
  )
}
